import Big from 'big.js';
import * as m from '$lib/paraglide/messages';
import * as yup from 'yup';

const INT32_MAX = 2_147_483_647;
const INT32_MIN = -2_147_483_648;
const FLOAT_SIGNIFICANT_DIGITS = 6;

yup.addMethod(yup.number, 'int32', function int32() {
  return this.integer().max(INT32_MAX).min(INT32_MIN);
});

yup.addMethod(yup.number, 'long', function long() {
  return this.integer();
});

yup.addMethod(yup.number, 'float32', function float32() {
  return this.test('float32-validation', m.common_validation_invalidNumber(), (value) => {
    if (value === null || value === undefined) return true;
    return value === Number(value.toPrecision(FLOAT_SIGNIFICANT_DIGITS));
  });
});

yup.addMethod(
  yup.number,
  'decimal',
  function decimal(maxIntegerDigits: number, maxDecimalDigits: number) {
    return this.test(
      'decimal-validation',
      m.common_validation_decimal({ integer: maxIntegerDigits, decimal: maxDecimalDigits }),
      (value) => {
        if (value === null || value === undefined) return true;
        const normalized = Big(value).abs();
        const integerDigits = Math.max(normalized.e + 1, 1);
        const decimalDigits = Math.max(normalized.c.length - (normalized.e + 1), 0);
        return integerDigits <= maxIntegerDigits && decimalDigits <= maxDecimalDigits;
      }
    );
  }
);

yup.addMethod(yup.string, 'notBlank', function notBlank() {
  return this.matches(/^(?! +$).*/, m.common_validation_whitespaceOnly()).required();
});
